import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import _noop from 'lodash/noop';
import { FormError, FormGroup, FormLabel } from 'components/Form';

const FormGroupField = ({
  input,
  label,
  type,
  isInline,
  isArchived,
  meta: { touched, error, active },
  onInputRef,
  errorClassName,
  ...restProps
}) => (
  <FormGroup
    active={active}
    className={cn({
      // TODO: this will be refactored
      inline: isInline,
      'is-filled': input.value !== '',
    })}
    error={error}
    touched={touched}
  >
    {label && <FormLabel htmlFor={input.name}>{label}</FormLabel>}
    <div className="form__control">
      <input
        className={cn('form__field', {
          'is-archived ': isArchived,
        })}
        {...input}
        ref={onInputRef}
        id={input.name}
        type={type}
        {...restProps}
      />
      {type === 'number' && (
        <FormLabel className="icon-pagin-down caret" htmlFor={input.name} />
      )}
    </div>

    {touched && error && (
      <FormError className={errorClassName}>{error}</FormError>
    )}
  </FormGroup>
);

FormGroupField.propTypes = {
  errorClassName: PropTypes.string,
  input: PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
  isArchived: PropTypes.bool,
  isInline: PropTypes.bool,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  meta: PropTypes.shape({
    active: PropTypes.bool,
    disabled: PropTypes.bool,
    error: PropTypes.string,
    touched: PropTypes.bool,
  }),
  type: PropTypes.string,
  onInputRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
};

FormGroupField.defaultProps = {
  input: {
    name: '',
    value: '',
  },
  label: '',
  type: '',
  meta: {
    active: false,
    touched: false,
    error: '',
  },
  isInline: false,
  isArchived: false,
  errorClassName: '',
  onInputRef: _noop,
};

export default FormGroupField;
